// import 'slick-carousel'
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, l ] = [ window, document, location ]

const init = () => {

  //mainvisual キャッチにクラス付与
  Promise.all([ w.load['mainvisual'] ]).then( () => {
    $('.mainvisual__catch').addClass('is-start')
  })

  // works
  $.when(w.load['block-news']).then( () => {
    let makeItem = item => $(`
      <li class="block-news-item">
        <a href="${item.href}">
          <div class="block-news__body">
            <span class="date">${item.date}</span>
            <span class="cate">【${item.category.name}】</span>
            <span class="subject ${item.is_new ? 'is-new': ''}">${item.title.str_truncate(24)}</span>
          </div>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem })
  })
  // works
  $.when(w.load['block-works']).then( () => {
    let makeItem = item => $(`
    <li class="block-works-item">
      <a href="${item.href}">
        <figure class="block-works__img">
          <div class="block-works__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="302" loading="lazy"></div>
        </figure>
        <div class="block-works__body">
          <span class="subject">${item.title.str_truncate(24)}</span>
          <div class="btnwrap hidden-xsmall">
            <button type="button" class="button button-border-white">READ MORE</button>
          </div>
        </div>
      </a>
    </li>
    `)[0]
    GET_ARTICLES('.block-works__list[data-plugin="getArticles"]', { makeItem })
  })
}

export default function HOME() {
  $( init )
}